import { IconButton, makeStyles, TextField } from '@material-ui/core';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../reducers';
import { findSubTreeByNodeId } from '../ComponentManagementPage/utils';
import ClearIcon from '@material-ui/icons/Clear';
import { getTitleTreeByNumber } from '../../api/title';
import { ComponentManagementActionType } from '../../reducers/comp.actions';
import { getNodeById } from '../../api/node';
import { UiActionType } from '../../reducers/ui.reducer';

const useStyles = makeStyles((_) => ({
  root: {
    marginTop: 15,
    marginLeft: 10,
    marginRight: 15,
    marginBottom: 15,
    width: 300,
  },
  labelRoot: {
    color: 'rgba(0,0,0,.55)',
  },
}));

type Props = {
  history: any;
};

const TitleSearchComponent: React.FC<Props> = ({ history }) => {

    const [query, setQuery] = useState<string>("");
    const classes = useStyles();
    const treeRoot = useSelector((app: ApplicationState) => app.comp.treeRoot);
    const location = useLocation();
    const dispatch = useDispatch();
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);

  useEffect(() => {
    if (!treeRoot) {
      setQuery("");
      return;
    }

    const nodeIdParameter = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    }).node as string;
    if (nodeIdParameter) {
      const nodeId = parseInt(nodeIdParameter);
      const searchNode = findSubTreeByNodeId(treeRoot, nodeId);
      if (searchNode) {
        setQuery(searchNode.citation);
      }
    }
  }, [location.search, treeRoot]);

  const submitSearch = (event: any) => {
    event.preventDefault();

        if (treeRoot && editorNode && query === editorNode.citation) {
            getTitleTreeByNumber(treeRoot.citation).then(response => {
                dispatch({ type: ComponentManagementActionType.TREE_ROOT_UPDATED, treeRoot: response.data });
            }).catch(error => {
                console.error(error);
            })
        }
        if (editorNode?.nodeId && query === editorNode.citation) {
            getNodeById(editorNode?.nodeId).then(response => {
                dispatch({ type: ComponentManagementActionType.EDITOR_NODE_UPDATED, editorNode: response.data });
            }).catch(error => {
                console.error(error);
                dispatch({type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Node content could not be loaded, please try again later.", severity: "error"}});
            })

        }
    // Parse tokens from the query string
    const tokens = query
      .replaceAll("(", "-")
      .replaceAll(")", "-")
      .split("-")
      .filter((t) => t.length > 0);

    // Build the path dynamically based on available tokens
    if (tokens.length > 0) {
      const path = `/component/${tokens.slice(0, 7).join("/")}`;
      history.push(path);
    } else {
      history.push(`/component/${query}`);
    }
  };

  return (
    <form onSubmit={(e) => submitSearch(e)}>
      <TextField
        className={classes.root}
        label="Search by citation"
        InputLabelProps={{ shrink: true, htmlFor: "citation-search", classes: { root: classes.labelRoot } }}
        inputProps={{
          id: "citation-search"
        }}
        InputProps={{
          endAdornment:
            query && query.length > 0 ? (
              <IconButton
                size="small"
                onClick={() => {
                  setQuery("");
                }}
              >
                <ClearIcon />
              </IconButton>
            ) : null,
        }}
        variant="outlined"
        size="small"
        placeholder="1-1-110(5)(a)(ii)"
        value={query || ''}
        onChange={(e: any) => {
          setQuery(e.target.value);
        }}
      />
    </form>
  );
};

export default withRouter(TitleSearchComponent);
